// Store
import ModalStore from "@/store/modal-store";
import UserStore from "@/store/user-store";
import ModalSheetStore from "@/store/modal-sheet-store";

export const useStore = () => {
  return {
    modal: ModalStore(),
    modalSheet: ModalSheetStore(),
    user: UserStore(),
  };
};
